<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @search-reset="searchClear"
        @row-save="handleSave" @row-update="handleUpdate" @selection-change="handleSelectionChange"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" plain @click.stop="handleAdd()">新增</el-button>

          <el-button type="success" icon="el-icon-download" size="small" plain
            @click="downloadExceltest(scope.row)">下载Excel</el-button>
          <el-button type="warning" icon="el-icon-delete" size="small" plain
            @click.stop="handleDel('LOGICAL', '逻辑删除')">删除</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" plain
            @click.stop="handleDel('PHYSICAL', '物理删除')">物理删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <!-- 查看 -->
          <el-button type="success" icon="el-icon-view" size="small" @click.stop="handleView(scope.row, scope.index)">
            查看
          </el-button>
          <el-button type="warning" icon="el-icon-edit" size="small"
            @click.stop="handleEdit(scope.row, scope.index)">编辑</el-button>
        </template>
        <template slot-scope="scope" slot="menuForm">
          <el-button type="primary" size="medium" plain v-if="scope.type == 'view'"
            @click="downloadExcelView(scope.row)">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="previousPhotos">
          <viewer :images="formmaterImage(scope.row.previousPhotos)">
            <img v-for="src in formmaterImage(scope.row.previousPhotos)" :src="src" :key="src" width="20" />
          </viewer>
        </template>
        <template slot-scope="scope" slot="midTermPhotos">
          <viewer :images="formmaterImage(scope.row.midTermPhotos)">
            <img v-for="src in formmaterImage(scope.row.midTermPhotos)" :src="src" :key="src" width="20" />
          </viewer>
        </template>
        <template slot-scope="scope" slot="completionPhotos">
          <viewer :images="formmaterImage(scope.row.completionPhotos)">
            <img v-for="src in formmaterImage(scope.row.completionPhotos)" :src="src" :key="src" width="20" />
          </viewer>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>
<script>
import { customerFileTableOption } from '@/const/salesCloud/customerFileOption';
import {
  findCustomerInfo,
  addCustomerInfo,
  editCustomerInfo,
  delCustomerInfo,
  delForceCustomerInfo,
  findClassifySelect,
  findStaffSelect,
  findProjectSelect,
  findShopInfoSelect,
  downloadExcelV2
} from "@/api/salesCloud/customerFile";
import {
  findItemsByCategory,
  findCategoryAll
} from "@/api/salesCloud/workOrder";
import { DIC } from "@/const/dic";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus, resolveUrlPath, findByLabel } from "@/util/util";
import { findUserList } from "@/api/salesCloud/bindEngineer";

export default {
  name: "customerFile",
  data() {
    return {
      tableOption: customerFileTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      currservicePeople: "",
      currservicePeoples: [],
      joinsWorkServiceItems: [],
      serviceCategory: {},
      serviceCategorys: [],
      serviceItem: "",
      tableLoading: false,
      classifySelects: [],
      secondClassifySelects: [],
      staffinstallSelects: [],
      staffdebugSelects: [],
      planIdSelects: [],
      shopNameSelects: [],
      gatherPlans: [],
      currClassify: "",
      currSecondClassify: "",
      currInstallStaffSelect: [],
      searchInstallStaffSelect: "",
      currDebugStaffSelect: [],
      searchDebugStaffSelect: "",
      currPlanSelect: "",
      searchPlanSelect: "",
      currShopNameSelect: {
        name: "",
        mobile: ""
      },
      currShopMobileSelect: "",
      tabelObj: {},
      point: { address: "" },
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
    findClassifySelect().then(res => {
      let data = JSON.parse(res.data);
      this.classifySelects = data;
    });
    findStaffSelect().then(res => {
      let data = JSON.parse(res.data);
      this.staffinstallSelects = data;
      this.staffdebugSelects = data;
    });
    findProjectSelect().then(res => {
      let data = JSON.parse(res.data);
      this.planIdSelects = data;
    });
    findShopInfoSelect().then(res => {
      let data = JSON.parse(res.data);
      this.shopNameSelects = data;
    });
    findCategoryAll().then(res => {
      console.log(res);
      let data = JSON.parse(res.data);
      this.serviceCategorys = data.rows;
    });
  },
  watch: {},
  mounted() { },
  computed: {},
  props: [],
  methods: {
    formmaterImage(row) {
      let str = new Array();
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      // console.log(str);
      return str;
    },
    remoteMethod(query) {
      console.log(query);
      if (query.length == 5) {
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.currservicePeoples = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.currservicePeoples = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    choseServiceItem(data) {
      console.log(data);
      this.serviceItemId = data;
      console.log(this.serviceItemId);
    },
    choseWorkServiceItem() {
      console.log(this.serviceCategory.id);
      findItemsByCategory(this.serviceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
        console.log(res);
        console.log(data);
      });
      this.serviceItem = "";
    },
    downloadExceltest() {
      let params = this.$refs.crud.searchForm;
      downloadExcelV2(params).then((response) => {
        // 提取文件名
        const filename = "客户档案信息.xlsx"
        // 将二进制流转为blob
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename))
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob)
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', decodeURI(filename))
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
          }
          // 挂载a标签
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL)
          //带参数刷新
          this.searchChange(params);
        }
      });
    },
    choseshopNameSelect() {
      console.log(this.currShopNameSelect);
      this.currShopMobileSelect = this.currShopNameSelect.mobile;
      console.log(this.currShopMobileSelect);
    },
    handleGatherPlansAddRows() {
      var list = {
        checkTime: new Date(),
        content: ""
      };
      this.gatherPlans.unshift(list);
    },
    handleGatherPlansDelete(index, row) {
      this.gatherPlans.splice(index, 1);
    },
    chosefirstClassifyId() {
      this.currSecondClassify = "";
      this.secondClassifySelects = [];
      console.log(this.currClassify);
      let params = {};
      params.rootId = this.currClassify;
      if (params.rootId) {
        findClassifySelect(params).then(res => {
          let data = JSON.parse(res.data);
          console.log(data);
          this.secondClassifySelects = data;
        });
      }
    },
    clean() {
      this.currClassify = "";
      this.currSecondClassify = "";
      this.point = {};
      this.point.address = "";
      this.currPlanSelect = "";
      this.gatherPlans = [];
      this.currDebugStaffSelect = [];
      this.currInstallStaffSelect = [];
    },
    searchClear() {
      this.serviceCategory = {};
      this.serviceItem = "";
      this.currClassify = "";
      this.searchPlanSelect = "";
      this.searchInstallStaffSelect = "";
      this.currservicePeople = ""; //服务人员
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.serviceCategory = this.serviceCategory.id;
      params.serviceItem = this.serviceItem;
      params.servicePeople = this.currservicePeople;
      // console.log(params);
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.updateTimeStart = params.startDate_endDate[0];
        params.updateTimeEnd = params.startDate_endDate[1];
      } else {
        delete params.updateTimeStart;
        delete params.updateTimeEnd;
      }
      this.downloadData = params;
      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;

      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      // this.clean();
      // this.$refs.crud.rowAdd();
      let obj = {
        label: "新增客户信息",
        value: "customerFile/add"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label)
      });
    },
    // 查看
    handleView(row,index){
      let obj = {
        label: "查看客户信息",
        value: "customerFile/view",
        query: { id: row.id }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    handleEdit(row, index) {
      let obj = {
        label: "编辑客户信息",
        value: "customerFile/edit",
        query: { id: row.id }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;

      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      if (!this.point.address) {
        this.$message({
          showClose: true,
          message: "客户地址及坐标不能为空",
          type: "error"
        });
        done();
      }
      row.firstClassifyId = this.currClassify;
      row.secondClassifyId = this.currSecondClassify;
      row.details = this.gatherPlans;
      row.details = row.details.map(item => {
        if ("" != item.checkTime) {
          item.checkTime = item.checkTime ? item.checkTime.getTime() : 0;
        }
        return item;
      });
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pcode;
      row.city = this.point.adcode.substring(0, 4) + "00";
      row.area = this.point.adcode;
      row.provinceName = this.point.pname;
      row.cityName = this.point.cityname;
      row.areaName = this.point.adname;
      row.address = this.point.address;
      row.secondClassifyId = this.currSecondClassify;
      row.shopId = this.currShopNameSelect.id;
      if (this.currInstallStaffSelect) {
        row.installStaffId = this.currInstallStaffSelect.join(",");
      }
      if (this.currDebugStaffSelect) {
        row.debugStaffId = this.currDebugStaffSelect.join(",");
      }
      row.planId = this.currPlanSelect;
      delete row.debugStaffName;
      delete row.installStaffName;
      console.log(this.point);
      console.log(row);
      if (row.address && row.province) {
        addCustomerInfo(row).then(res => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "新增成功",
              type: "success"
            });
            done();
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            done();
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "客户地址及坐标不能为空",
          type: "error"
        });
      }
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },

    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(value) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          // console.log(ids);
          delCustomerInfo(findByLabel(DIC.DELETE_OPTION, value), ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row);
      console.log(this.point);
      row.firstClassifyId = this.currClassify;
      row.secondClassifyId = this.currSecondClassify;
      row.details = this.gatherPlans;
      row.details = row.details.map(item => {
        if ("" != item.checkTime) {
          item.checkTime = item.checkTime ? item.checkTime.getTime() : 0;
        }
        return item;
      });
      row.longitude = row.longitude * 1;
      row.latitude = row.latitude * 1;
      row.address = this.point.address;
      console.log(this.point.location);
      if (this.point.location) {
        row.longitude = this.point.location.lng;
        row.area = this.point.adcode;
        row.provinceName = this.point.pname;
        row.cityName = this.point.cityname;
        row.city = this.point.adcode.substring(0, 4) + "00";
        row.areaName = this.point.adname;
        row.latitude = this.point.location.lat;
        row.province = this.point.pcode;
        row.address = this.point.address;
      }
      row.secondClassifyId = this.currSecondClassify;
      row.shopId = this.currShopNameSelect.id;
      if (this.currInstallStaffSelect) {
        row.installStaffId = this.currInstallStaffSelect.join(",");
      }
      if (this.currDebugStaffSelect) {
        row.debugStaffId = this.currDebugStaffSelect.join(",");
      }
      row.planId = this.currPlanSelect;
      delete row.debugStaffName;
      delete row.installStaffName;
      editCustomerInfo(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
